const text = () => {
  return {
    text: {
      text: [],
      actions: [],
      selected: null
    }
  };
};

const initialArea = (params) => {
  if (params.origin) {
    return "EditorSimple"
  }
  return params.productId ? "Landing" : "ProductSelector";
};


const all = (params = {}) => {
  const images = {};
  images.filter = params.filter || { name: null, src: null };
  images.border = params.border || { name: null, src: null };
  images.result = params.result || { src: null };
  images.origin = params.origin || { src: null, uploaded: false };
  images.crop = params.crop || { src: null, x: 0, y: 0, scale: 1 };
  return {
    ...text(),
    area: params.area || initialArea(params),
    images,
    loading: false,
    error: null,
    filtered: {},
    labelId: null,
    labelUrl: null,
    border: null,
    label: null,
    template: null
  };
};

export default { text, all };



// WEBPACK FOOTER //
// ./src/misc/initial-state.js